import React from 'react';

import {gettext} from 'utils/text';


const ReportsTips = () => (
    <div style={{textAlign: "center"}}>
        <em className="text-muted">{gettext("Tip: Hold shift when sorting to multi-sort!")}</em>
    </div>
);


export default ReportsTips;



// WEBPACK FOOTER //
// ./src/components/ReportsTips.js